<div role="group" class="app-basic-editor" [formGroup]="contentInput">
  <angular-editor formControlName="content" [config]="config"></angular-editor>
</div>
<span class="text-muted">Images must be maximum 350Kb, images that exceed this will fail silently</span>
@if (debug) {
  <div>
    <div class="w-100 my-3">{{value}}</div>
    <div class="w-100" [innerHTML]="value"></div>
  </div>
}
